import React, { useState, useEffect } from 'react';
import { Text } from '@applane/react-core-components';
import Toast from '@applane/react-toast';
import Generated from './Generated';
import Captured from './Captured';
import vars from '../../theme/vars';
import { ViewAppraisalResult } from './View';
import { cancelButton, DateFilter, save } from '../../app-components';
import { emailIcon, messageIcon, printerIcon } from '../../images';
import { IconButton } from '../../app-components/buttons/Buttons';
import { invoke } from '../../AppServices';
import { getUserRole } from '../../Lib/helpers';
import FtsSearch from '../../Components/TableFilters/FtsSearch';
import { MODELS, ROUTES } from '../../Lib/constants';
// import * as FileSaver from 'file-saver'
import '../Welcome/loader.css'
import { BASE_URL } from '../../Config';
import { getUser } from '../../AppServices';
import { modifyDateView } from '../../Lib/helpers';
import Test from './Test';
// import Captur from './Captur';
import Generate from './Generated';
import CapturedAppraisal from './CapturedAppraisal';

// import Captur from './Captured';
// import Generate from './Generated';

const axios = require('axios');

const { headings } = vars;
const textStyle = { ...headings.pageHeading, marginLeft: 12 };

export const ViewButtonsList = ({id, setView}) => {
  console.logs('viewButtonsList')
  const arr = [];

  const showButtonsList = true;

  arr.push(cancelButton);
  arr.push(save);

  if (getUserRole() === 'dealer' && showButtonsList) {
    // print button
    arr.push({
      render: () => (
        <IconButton
          onClick={async () => {
            window.print();
            await invoke({
              id: 'appraisalResultPrint',
              paramValue: {
                appraisalId: id,
              },
            });

            // props.eventDispatcher.notify(
            //   ROUTES.AppraisalGeneratedListReload.name,
            // );
          }}
          description="Print"
          tooltipId="printer-icon"
          style={{ usingIcon: true }}
          icon={printerIcon}
          iconStyle={{ height: 20, width: 20 }}
          stylelg={{ paddingLeft: 0, paddingRight: 0 }}
          labelStyle={{
            fontSize: 18,
            color: '#ffffff',
            fontFamily: 'Mulish-SemiBold',
          }}
        />
      ),
    });

    // sms button
    arr.push({
      render: () => (
        <IconButton
          onClick={async () => {
            const fromBack = await invoke({
              id: 'appraisalResultMessage',
              paramValue: {
                appraisalId: id,
              },
            });
            if (fromBack.result) {
              Toast.show(fromBack.result);
            } else {
              Toast.show(
                {
                  message: fromBack.responseMessage,
                  type: 'warning',
                  position: 'top',
                  direction: 'left',
                });

            }
            // props.eventDispatcher.notify(
            //   ROUTES.AppraisalGeneratedListReload.name,
            //   fromBack,
            // );
          }}
          description="Send Message"
          tooltipId="appraisal-generated-send-message"
          style={{ usingIcon: true }}
          icon={messageIcon}
          iconStyle={{ height: 20, width: 20 }}
          stylelg={{ paddingLeft: 0, paddingRight: 0 }}
          labelStyle={{
            fontSize: 18,
            color: '#ffffff',
            fontFamily: 'Mulish-SemiBold',
          }}
        />
      ),
    });

    // mail button
    arr.push({
      render: () => (
        <IconButton
          onClick={async () => {
            const mailResultFromBack = await invoke({
              id: 'sendAppraisalResultMail',
              paramValue: {
                appraisalId: id,
              },
            });

            if (mailResultFromBack.statusCode === 202) {
              await invoke({
                id: 'updateMailOfferCountAndOfferList',
                paramValue: {
                  appraisalId: id,
                },
              });
              Toast.show({
                message: 'Success',
                description: 'Email Sent.',
                type: 'success',
                position: 'top',
                direction: 'left',
              });
            } else {
              Toast.show({
                message: mailResultFromBack.responseMessage,
                type: 'warning',
                position: 'top',
                direction: 'left',
              });
            }

            // props.eventDispatcher.notify(
            //   ROUTES.AppraisalGeneratedListReload.name,
            //   mailResultFromBack,
            // );
          }}
          description="Send Email"
          tooltipId="appraisal-generated-send-email"
          style={{ usingIcon: true }}
          icon={emailIcon}
          iconStyle={{ height: 20, width: 20 }}
          stylelg={{ paddingLeft: 0, paddingRight: 0 }}
          labelStyle={{
            fontSize: 18,
            color: '#ffffff',
            fontFamily: 'Mulish-SemiBold',
          }}
        />
      ),
    });
  }

  return arr;


};



export default {
  [ROUTES.ARListAvgen.name]: {
    screen: Test,
    expanded: true,
    // title: () => <Text style={textStyle}>Appraisals Generated List
    //       <AVGenModal />
    //   <svg xmlns="http://www.w3.org/2000/svg" data-toggle="modal" data-target="#basicModal" viewBox="0 0 20 20" fill="currentColor" style={{height:"2.2rem", width:"2.2rem", "marginLeft": "2rem", cursor:"pointer"}} >
    //     <path d="M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" />
    //     <path fill-rule="evenodd" d="M.664 10.59a1.651 1.651 0 0 1 0-1.186A10.004 10.004 0 0 1 10 3c4.257 0 7.893 2.66 9.336 6.41.147.381.146.804 0 1.186A10.004 10.004 0 0 1 10 17c-4.257 0-7.893-2.66-9.336-6.41ZM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z" clip-rule="evenodd" />
    //   </svg>

    //   <ExportExcel fileName={"Appraisal Generated Report"} margin={"350px"} marginTwo={"300px"} />
    // </Text>,
    // headerActions: [
    //   (props) => (
    //     <FtsSearch
    //       {...props}
    //       placeholder="Search by Appraisal#/VIN/Mobile/Email"
    //       width={500}
    //       action={{
    //         exp: [
    //           'dms.repairOrderNumber',
    //           'dms.contactNumber',
    //           'dms.email',
    //           'dms.vin',
    //           'dms.name',
    //         ],
    //       }}
    //     />
    //   ),
    //   {
    //     render: <DateFilter field="onDate" key="onDate" />,
    //   },
    // ],
  },

  [ROUTES.ARListUCI.name]: {
    screen: CapturedAppraisal,
    expanded: true,
    // title: () => <Text style={textStyle}>Appraisals Captured List
    //   <AVCapModal />
    //   {/* <svg xmlns="http://www.w3.org/2000/svg" data-toggle="modal" data-target="#basicModal" viewBox="0 0 20 20" fill="currentColor" style={{height:"2.2rem", width:"2.2rem", "marginLeft": "2rem", cursor:"pointer"}} >
    //     <path d="M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" />
    //     <path fill-rule="evenodd" d="M.664 10.59a1.651 1.651 0 0 1 0-1.186A10.004 10.004 0 0 1 10 3c4.257 0 7.893 2.66 9.336 6.41.147.381.146.804 0 1.186A10.004 10.004 0 0 1 10 17c-4.257 0-7.893-2.66-9.336-6.41ZM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z" clip-rule="evenodd" />
    //   </svg>

    //   <ExportExcelAVCaptured fileName={"Appraisal Captured Report"} margin={"550px"} marginTwo={"500px"} /> */}
    // </Text>,
    // headerActions: [
    //   (props) => (
    //     <FtsSearch
    //       {...props}
    //       placeholder="Search by Appraisal#/VIN/Mobile/Email"
    //       width={500}
    //       action={{
    //         exp: [
    //           'dms.repairOrderNumber',
    //           'dms.contactNumber',
    //           'dms.email',
    //           'dms.vin',
    //           'dms.name',
    //         ],
    //       }}
    //     />
    //   ),
    // ],
  },

  'appraisal-result-list-avgen-back': {
    screen: Generated,
    expanded: true,
    // title: () => <Text style={textStyle}>Appraisals Generated List
    //   {/* <ExportExcel fileName={"Appraisal Generated Report"} margin={"400px"} marginTwo={"350px"} /> */}
    // </Text>,
    // headerActions: [
    //   (props) => (
    //     <FtsSearch
    //       {...props}
    //       placeholder="Search by Appraisal/VIN/Mobile/Email"
    //       action={{
    //         exp: [
    //           'dms.repairOrderNumber',
    //           'dms.contactNumber',
    //           'dms.email',
    //           'dms.vin',
    //           'dms.name',
    //         ],
    //       }}
    //     />
    //   ),
    //   {
    //     render: <DateFilter field="checkDate" key="checkDate" />,
    //   },
    //   cancelButton,
    // ],
  },

  'appraisal-result-list-uci-back': {
    screen: Captured,
    expanded: true,
    // title: () => <Text style={textStyle}>Appraisals Captured List
    //   <ExportExcelAVCaptured fileName={"Appraisal Captured Report"} margin={"600px"} marginTwo={"550px"} />
    // </Text>,
    // headerActions: [
    //   (props) => (
    //     <FtsSearch
    //       {...props}
    //       placeholder="Search by Appraisal#/VIN/Mobile/Email"
    //       width={500}
    //       action={{
    //         exp: [
    //           'dms.repairOrderNumber',
    //           'dms.contactNumber',
    //           'dms.email',
    //           'dms.vin',
    //           'dms.name',
    //         ],
    //       }}
    //     />
    //   ),
    //   cancelButton,
    // ],
  },

  // [ROUTES.viewAppraisalResult.name]: {
  //   screen: ViewAppraisalResult,
  //   expanded: true,
  //   title: ({ navigation }) => (
  //     <Text style={textStyle}>
  //       View Appraisal
  //       {navigation?.state?.params?.item?.type === 'uci'
  //         ? ' Captured'
  //         : ' Generated'}
  //     </Text>
  //   ),
  //   headerActions: (props) => viewButtonsList(props),
  // },
};
